import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
HttpClient

@Injectable({
  providedIn: 'root'
})
export class PrintassetService {

  constructor(private http: HttpClient) { }

  public token = ''

  getcampusdetail() {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(environment.printasseturl + '/apiV2/common/empCampuses', { headers });
  }

  getbuildingdetail(campusid: any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(environment.printasseturl + '/apiV2/common/empCmpBuilding?campusId=' + campusid, { headers });
  }

  gettabledetail(buildingid: any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(environment.orgUrl + '/apiV2/assetTracking/approvedAssetList?buildingId=' + buildingid, { headers });;
  }

  getgeneratepdf(entityQRId: any): Observable<Blob> {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(environment.orgUrl + '/apiV2/assetTracking/generatePdf?entityQRId=' + entityQRId, { headers, responseType: 'blob', });
  }

}
